import { FilterAPI } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';
import { DataContext } from '@philips-internal/oswald-ui-core/lib/component/context';
import { FoundationUtils } from './foundation-utils';

export class EletronicPrescriptionsUtils {
  static getFilterParams(): Record<string, Value> {
    const hour = FoundationUtils.findModuleParam('ADEP#1113', 'FIRST_FILTER_TIME#151') as string;
    const hrPrevious = FoundationUtils.findModuleParam('ADEP#1113', 'DEFAULT_PREVIOUS_HOURS_MANAGEMENT_TAB_FILTER#94') as number;
    const hrAdditional = 72;

    return {
      hour,
      hrAdditional,
      hrPrevious,
    };
  }

  static getFilterInitialData(filter: FilterAPI, parent: DataContext): Record<string, Value> {
    const params = EletronicPrescriptionsUtils.getFilterParams();
    const parentRecord = parent.get('filterRecord');
    if(parentRecord){
      return parentRecord;
    }
    const sessionStorageRecord = filter.getRecord() as Record<string, Value>;
    return filter.restoreState(true) ? sessionStorageRecord : params;
  }
}